import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as Colors from '@bubble-ui/particle-colors';
import * as FontSizes from '@bubble-ui/particle-font-sizes';
import * as FontFamilies from '@bubble-ui/particle-font-families';
import * as Grid from '@bubble-ui/particle-grid';
import * as Layers from '@bubble-ui/particle-layers';
import * as Breakpoints from '@bubble-ui/particle-breakpoints';
export default {
  // When preparing 💥 breaking release: Only remove the export, but keep the component!!!
  /**
   * @deprecated this component is outdated and will be removed with v5.0.0
   */
  Colors: Colors,
  ColorFunctions: Colors.ColorFunctions,
  // When preparing 💥 breaking release: Only remove the export, but keep the component!!!
  /**
   * @deprecated this component is outdated and will be removed with v5.0.0
   */
  Palette: Colors.palette,
  Fonts: _objectSpread(_objectSpread({}, FontSizes), FontFamilies),
  // When preparing 💥 breaking release: Only remove the export, but keep the component!!!
  /**
   * @deprecated this component is outdated and will be removed with v5.0.0
   */
  Grid: Grid,
  // When preparing 💥 breaking release: Only remove the export, but keep the component!!!
  /**
   * @deprecated this component is outdated and will be removed with v5.0.0
   */
  Layers: Layers,
  Breakpoints: Breakpoints
};
//# sourceMappingURL=constants.js.map